import { Star } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useChatStore } from "../../stores/chat";
import { favoritePath, useFavoritesStore } from "../../stores/favorites";
import { conversationTitle, favoriteLabel } from "./Sidebar";
import styles from "./FavoriteStar.module.css";

/**
 * Star the page you are on (owner, 2026-10-03: "any page can be added to the
 * favorites"). It rides in the top-right bar, which every page has, so a
 * module, one article, one project or a filtered view can all be starred the
 * same way. Filled when this exact address is already a favorite; pressing it
 * again removes it. The favorites themselves are listed in the sidebar.
 */
export function FavoriteStar({ className = "" }: { className?: string }) {
	const { t } = useTranslation();
	const location = useLocation();
	const path = favoritePath(location);
	const starred = useFavoritesStore((s) => s.favorites.some((f) => f.path === path));
	const toggle = useFavoritesStore((s) => s.toggle);
	const label = starred
		? t("nav.favoritePageRemove", "Remove this page from favorites")
		: t("nav.favoritePageAdd", "Add this page to favorites");
	return (
		<button
			type="button"
			className={`${className} ${starred ? styles.starred : ""}`}
			aria-pressed={starred}
			aria-label={label}
			title={label}
			onClick={() =>
				toggle({
					path,
					label:
						conversationTitle(location.pathname, useChatStore.getState().conversations) ??
						favoriteLabel(location, (item) => t(item.labelKey, item.labelFallback)),
				})
			}
		>
			<Star size={16} aria-hidden="true" fill={starred ? "currentColor" : "none"} />
		</button>
	);
}
